import * as THREE from 'three';
import { GraphNode } from './graph.js'

class TreeGraphNode extends GraphNode {
    constructor(parent){
        super();      
        if(parent){
          this.depth = parent.depth + 1;
          this.parent = parent;
            this.pos.add(parent.pos);
        } else {
          this.depth = 0;
        }

        this.childIndex = 0;
        this.collapsed = false;
        this.parent = parent;
        this.children = [];  
    }

    get data() {
      let childData = [];
      for( let child of this.children ){
        childData.push(child.data);
      }

      return {
        id: this.id, 
        pos: [this.pos.x,this.pos.y,this.pos.z], 
        pinned: this.pinned,
        enabled: this.enabled,
        children: childData,
        depth: this.depth
      }
    }

    set data(data) {
      this.depth = data.depth;
      this.pos = new THREE.Vector3( parseFloat(data.pos[0]), parseFloat(data.pos[1]), parseFloat(data.pos[2]) ); 
      this.pinned = data.pinned;
      this.enabled = data.enabled;
      for(let child of data.children) {
        let node = this.createChildNode();
        node.data = child;
      }      
    }

    loadData(data) {
      addedNodes = [];
      this.data = data;
      return addedNodes;
    }

    toggle() {
        this.enabled = !this.enabled;
    }  
    createChildren(depthToGo, branches) {
      if(depthToGo === 0)      
        return this.destroyChildren();


        while( branches > this.children.length ){
            this.createChildNode(depthToGo, branches);
        }  

        while( branches < this.children.length ) {
          this.destroyChild(this.children.pop());
        }
        
        this.children.forEach( (child) => {
            child.isParent = true;
            child.createChildren(depthToGo-1, branches);  
        });
    }
    destroy() {
      trashedNodes.push(this);
    }
    destroyChild(child) {
      child.destroyChildren();
      child.destroy();
      let index = this.edges.indexOf(child);
      this.edges.splice(index,1);  
    }
    destroyChildren() {
      this.children.forEach( (child) => this.destroyChild(child));
      this.children = [];
    }
    createChildNode() {
        let childGraph = new TreeGraphNode(this);
        this.connect(childGraph);
        this.children.push(childGraph);
        addedNodes.push(childGraph);
        return childGraph;
    }  
}

let trashedNodes = [];
let addedNodes = [];    
function treeGraph(depth, branches, position) {
  trashedNodes = [];
  addedNodes = [];          
  let root = new TreeGraphNode(0);
  if(position){
    root.pos = position;
    root.pinned = true;
  }
  let graph = [root];
  root.createChildren(depth, branches);
  graph = graph.concat(addedNodes);
  return graph;
}

function updateGraph(graph, depth, branches) {
  trashedNodes = [];
  addedNodes = [];      
  let node = graph[0];
  node.createChildren(depth, branches);  
  graph = graph.concat(addedNodes);
  trashedNodes.forEach(n => graph.splice(graph.indexOf(n),1));
  return {graph, trashedNodes, addedNodes};
}

function everyChild( graph, callback ) {
  for(let node of graph.children) {
      everyChild(node, callback);
      callback(node);
  }
}

export { TreeGraphNode, treeGraph, everyChild, updateGraph }